export interface IDepartment {
  departmentID: number;
  name: string;
}

export interface IDepartmentInfo {
  departmentID: number;
  name: string;
  parentID: number;
  parentDepartment: string;
  // workstyleID: number;
  // workstyleText: string;
  // flextime: boolean;
  isClosed: boolean;
  managerUserID: number;
  workmanageId: number[];
}

export class CDepartment implements IDepartmentInfo {
  public departmentID = 0;
  public name = '';
  public parentID = 0;
  public parentDepartment = '';
  // public workstyleID = 0;
  // public workstyleText = '';
  // public flextime = false;
  public isClosed = false;
  public managerUserID = 0;
  public workmanageId: number[] = [];
}
